import React from 'react';

import { useBreakpoint } from '@lib/hooks/useBreakpoints';

import Typography from '@components/Typography';

import { ContentProps } from './types';

const Content: React.FC<ContentProps> = ({ color, label, testID, amount, isTotal }) => {
    const breakpoint = useBreakpoint();

    return (
        <>
            <Typography
                color={color}
                variant={breakpoint === 'sm' ? 'p3' : 'p1'}
                semibold={isTotal}
            >
                {label}
            </Typography>
            <Typography
                testID={testID}
                color={color}
                variant={breakpoint === 'sm' ? 'p3' : 'p1'}
                semibold
            >
                {amount}
            </Typography>
        </>
    );
};

export default Content;
